import { apiClient } from '../client'

interface OTPLoginRequest {
  code: string
}

interface OTPLoginResponse {
  access_token: string
}

/** Returns a polaris access token. */
export function otpLogin({ code }: OTPLoginRequest): Promise<OTPLoginResponse> {
  return apiClient
    .get('auth/login/otp', {
      searchParams: {
        code,
      },
    })
    .json<OTPLoginResponse>()
}

interface SendOTPByEmailRequest {
  email: string
}

/** Returns a polaris access token. */
export function sendOTPByEmail({
  email,
}: SendOTPByEmailRequest): Promise<string> {
  return apiClient
    .post<void>('auth/otp', {
      json: {
        email,
      },
    })
    .text()
}
